/* tslint:disable */
/* eslint-disable */
/**
 * Protech PCS API
 * API for Protech PCS ingestion process
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerInvoice
 */
export interface CustomerInvoice {
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    id: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    vehicle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    service?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerInvoice
     */
    invoiceAmount?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof CustomerInvoice
     */
    invoiceDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    roNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerInvoice
     */
    hasInvoiceFile?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    customerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    customerRO?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CustomerInvoice
     */
    roCompleted?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerInvoice
     */
    vin?: string | null;
}

/**
 * Check if a given object implements the CustomerInvoice interface.
 */
export function instanceOfCustomerInvoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function CustomerInvoiceFromJSON(json: any): CustomerInvoice {
    return CustomerInvoiceFromJSONTyped(json, false);
}

export function CustomerInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerInvoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'vehicle': !exists(json, 'vehicle') ? undefined : json['vehicle'],
        'service': !exists(json, 'service') ? undefined : json['service'],
        'invoiceAmount': !exists(json, 'invoiceAmount') ? undefined : json['invoiceAmount'],
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'roNumber': !exists(json, 'roNumber') ? undefined : json['roNumber'],
        'hasInvoiceFile': !exists(json, 'hasInvoiceFile') ? undefined : json['hasInvoiceFile'],
        'customerId': !exists(json, 'customerId') ? undefined : json['customerId'],
        'customerRO': !exists(json, 'customerRO') ? undefined : json['customerRO'],
        'roCompleted': !exists(json, 'roCompleted') ? undefined : (json['roCompleted'] === null ? null : new Date(json['roCompleted'])),
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
    };
}

export function CustomerInvoiceToJSON(value?: CustomerInvoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'vehicle': value.vehicle,
        'service': value.service,
        'invoiceAmount': value.invoiceAmount,
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'invoiceNumber': value.invoiceNumber,
        'roNumber': value.roNumber,
        'hasInvoiceFile': value.hasInvoiceFile,
        'customerId': value.customerId,
        'customerRO': value.customerRO,
        'roCompleted': value.roCompleted === undefined ? undefined : (value.roCompleted === null ? null : value.roCompleted.toISOString()),
        'vin': value.vin,
    };
}

